'use client';
import { styled } from '@mui/material/styles';

import Radio from '@mui/material/Radio';

export const BaseRadioButton = styled(Radio)();
